import * as e from "react";
import { useState as $, useRef as Y, useCallback as de, useEffect as ae, Fragment as et } from "react";
import { bU as ze } from "./OBTResizeContainer-DJtJyPtj.js";
import { A as ml, a as ul, b as pl, c as El, d as bl, C as fl, e as yl, f as gl, g as hl, h as vl, i as kl, j as Nl, k as wl, l as $l, m as Al, n as xl, o as Xl, p as Cl, q as Sl, r as Fl, s as Bl, t as jl, u as Il, v as Ll, w as Dl, x as Ml, y as Tl, z as Rl, B as Pl, D as Ol, E as ql, F as Gl, G as zl, H as Wl, I as Kl, J as Hl, K as Vl, L as Ul, M as Ql, N as Jl, O as Yl, P as Zl, Q as ei, R as ti, S as ai, T as ni, U as oi, V as si, W as ri, X as ci, Y as li, Z as ii, _ as di, $ as _i, a0 as mi, a1 as ui, a2 as pi, a3 as Ei, a4 as bi, a5 as fi, a6 as yi, a7 as gi, a8 as hi, a9 as vi, aa as ki, ab as Ni, ac as wi, ad as $i, ae as Ai, af as xi, ag as Xi, ah as Ci, ai as Si, aj as Fi, ak as Bi, al as ji, am as Ii, an as Li, ao as Di, ap as Mi, aq as Ti, ar as Ri, as as Pi, at as Oi, au as qi, av as Gi, aw as zi, ax as Wi, ay as Ki, az as Hi, aA as Vi, aB as Ui, aC as Qi, aD as Ji, aE as Yi, aF as Zi, aG as ed, bV as td, aH as ad, aI as nd, aJ as od, aK as sd, aL as rd, aM as cd, aN as ld, aO as id, aP as dd, aQ as _d, aR as md, aS as ud, aT as pd, aU as Ed, aV as bd, aW as fd, aX as yd, aY as gd, aZ as hd, a_ as vd, a$ as kd, b0 as Nd, b1 as wd, b2 as $d, b3 as Ad, b4 as xd, b5 as Xd, b6 as Cd, b7 as Sd, b8 as Fd, b9 as Bd, ba as jd, bb as Id, bc as Ld, bd as Dd, be as Md, bf as Td, bg as Rd, bh as Pd, bi as Od, bj as qd, bk as Gd, bl as zd, bm as Wd, bn as Kd, bo as Hd, bp as Vd, bq as Ud, br as Qd, bs as Jd, bt as Yd, bu as Zd, bv as e_, bw as t_, bx as a_, by as n_, bz as o_, bA as s_, bB as r_, bC as c_, bD as l_, bE as i_, bF as d_, bG as __, bH as m_, bI as u_, bJ as p_, bK as E_, bL as b_, bM as f_, bN as y_, bO as g_, bP as h_, bQ as v_, bR as k_, bS as N_, bT as w_ } from "./OBTResizeContainer-DJtJyPtj.js";
import { a as A_, b as x_, f as X_, c as C_, d as S_, e as F_, g as B_, h as j_, t as I_ } from "./format-BpCURHRA.js";
const $c = {
  primary: "#1d4ed8",
  primaryBg: "#dbeafe",
  headerBg: "#1f2937",
  text: "#374151",
  textMuted: "#6b7280",
  border: "#e5e7eb",
  surface: "#f3f4f6"
}, Fe = "poc_portal_token", ye = "poc_portal_refresh", xe = "auth:session-expired", We = window.location.hostname === "dev.gennolab.co.jp" ? "" : "https://dev.gennolab.co.jp";
let Ke = We + "/chat-api/api/auth";
function Ac(t) {
  t.authBase && (Ke = t.authBase);
}
function we(t) {
  try {
    const a = t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(escape(atob(a))));
  } catch {
    return {};
  }
}
function tt(t, a = 30) {
  const n = we(t).exp;
  return !n || n * 1e3 < Date.now() + a * 1e3;
}
function He(t = 30) {
  const a = localStorage.getItem(ye);
  if (!a) return !0;
  const n = we(a).exp;
  return !!n && n * 1e3 < Date.now() + t * 1e3;
}
function Ve() {
  return localStorage.getItem(Fe);
}
function at(t, a) {
  localStorage.setItem(Fe, t), a && localStorage.setItem(ye, a);
}
function nt() {
  localStorage.removeItem(Fe), localStorage.removeItem(ye), Ue();
}
function be() {
  nt(), window.dispatchEvent(new Event(xe));
}
function xc(t) {
  return window.addEventListener(xe, t), () => window.removeEventListener(xe, t);
}
let fe = null;
const ot = 2147483647;
function st() {
  if (Ue(), He()) {
    be();
    return;
  }
  const t = localStorage.getItem(ye), a = t ? we(t).exp : void 0;
  if (!a) return;
  const n = Math.min(Math.max(a * 1e3 - Date.now() - 30 * 1e3, 0), ot);
  fe = setTimeout(() => {
    fe = null, st();
  }, n);
}
function Ue() {
  fe !== null && (clearTimeout(fe), fe = null);
}
let Ne = null;
function Qe() {
  return Ne || (Ne = rt()), Ne;
}
async function rt() {
  try {
    return await ct();
  } finally {
    Ne = null;
  }
}
async function ct() {
  const t = localStorage.getItem(ye);
  if (!t)
    return be(), null;
  let a;
  try {
    a = await fetch(Ke + "/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken: t })
    });
  } catch {
    return null;
  }
  if (!a.ok)
    return a.status < 500 && be(), null;
  const n = await a.json().catch(() => ({}));
  return n.access_token ? (at(n.access_token, n.refresh_token), n.access_token) : (be(), null);
}
async function lt() {
  if (He())
    return be(), null;
  const t = Ve();
  return t && !tt(t) ? t : Qe();
}
const Xe = "poc_portal_active_aff:", it = "X-Active-Com", dt = "X-Active-Dept";
function Je(t = Ve()) {
  return t && we(t).preferred_username || null;
}
function _t(t = Je()) {
  if (!t) return null;
  try {
    const a = localStorage.getItem(Xe + t);
    if (!a) return null;
    const n = JSON.parse(a);
    if (Number.isInteger(n == null ? void 0 : n.comSq) && typeof (n == null ? void 0 : n.deptCd) == "string" && n.deptCd)
      return { comSq: n.comSq, deptCd: n.deptCd };
  } catch {
  }
  return null;
}
function Xc(t, a) {
  if (t)
    try {
      a ? localStorage.setItem(Xe + t, JSON.stringify(a)) : localStorage.removeItem(Xe + t);
    } catch {
    }
}
function mt(t) {
  const a = _t(Je(t));
  return a ? { [it]: String(a.comSq), [dt]: a.deptCd } : {};
}
async function ge(t, a = {}) {
  const n = (s) => {
    var m;
    const l = (m = a.headers) != null ? m : {}, d = Object.keys(l).map((_) => _.toLowerCase()), c = mt(s), i = {};
    return Object.keys(c).forEach((_) => {
      d.indexOf(_.toLowerCase()) < 0 && (i[_] = c[_]);
    }), {
      ...a,
      headers: { ...l, ...s ? { Authorization: "Bearer " + s } : {}, ...i }
    };
  }, o = await lt();
  let r = await fetch(t, n(o));
  if (r.status === 401 && o) {
    const s = await Qe();
    s && (r = await fetch(t, n(s)));
  }
  return r;
}
let le = We + "/chat-api/api/comments";
function Cc(t) {
  t.base && (le = t.base);
}
function ut(t) {
  return t.parentId !== void 0 && t.parentId !== null;
}
async function he(t) {
  const a = await t.json().catch(() => ({}));
  if (!t.ok) throw new Error("요청을 처리하지 못했습니다. 잠시 후 다시 시도하세요.");
  return a;
}
async function Be(t, a, n, o, r) {
  const s = new URLSearchParams({ targetType: t, targetId: a, page: String(n), size: String(o) }), l = await ge(`${le}?${s}`, { cache: "no-store", signal: r });
  return he(l);
}
async function pt(t, a, n, o) {
  const r = await ge(le, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ targetType: t, targetId: a, content: n, parentId: o })
  });
  return he(r);
}
async function Et(t, a) {
  const n = await ge(`${le}/${t}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content: a })
  });
  return he(n);
}
async function bt(t) {
  const a = await ge(`${le}/${t}`, { method: "DELETE" });
  return (await he(a)).status;
}
async function ft(t, a, n) {
  if (a.length === 0) return {};
  const o = new URLSearchParams({ targetType: t, targetIds: a.join(",") }), r = await ge(`${le}/counts?${o}`, { cache: "no-store", signal: n });
  return (await he(r)).counts;
}
const je = 50;
function Ce(t) {
  return t.parentId === void 0 || t.parentId === null;
}
function yt(t, a) {
  if (Ce(a)) return [...t, a];
  const n = a.parentId;
  let o = -1;
  for (let r = 0; r < t.length; r += 1)
    (t[r].id === n || t[r].parentId === n) && (o = r);
  return o < 0 ? [...t, a] : [...t.slice(0, o + 1), a, ...t.slice(o + 1)];
}
function _e(t, a) {
  return a;
}
function gt(t, a) {
  const [n, o] = $([]), [r, s] = $(!0), [l, d] = $(!0), [c, i] = $(null), [m, _] = $(0), [u, b] = $(0), y = t + " " + a, E = Y(y);
  E.current = y;
  const [h, w] = $(0), X = de(() => w((f) => f + 1), []);
  ae(() => {
    const f = new AbortController(), v = y;
    return o([]), b(0), _(0), i(null), s(!0), d(!0), Be(t, a, 0, je, f.signal).then((g) => {
      E.current === v && (o(g.items), _(g.total));
    }).catch((g) => {
      f.signal.aborted || E.current !== v || i(_e(g, "댓글을 불러오지 못했습니다."));
    }).finally(() => {
      E.current === v && (s(!1), d(!1));
    }), () => f.abort();
  }, [t, a, y, h]);
  const O = n.filter(Ce).length < m, q = de(() => {
    if (r || !O) return;
    const f = u + 1, v = E.current;
    s(!0), Be(t, a, f, je).then((g) => {
      E.current === v && (o((S) => [...S, ...g.items]), _(g.total), b(f));
    }).catch((g) => {
      E.current === v && i(_e(g, "댓글을 더 불러오지 못했습니다."));
    }).finally(() => {
      E.current === v && s(!1);
    });
  }, [r, O, u, t, a]), V = de(async (f, v) => {
    const g = f.trim();
    if (!g) return !1;
    const S = -Date.now(), F = {
      id: S,
      targetType: t,
      targetId: a,
      parentId: v != null ? v : null,
      authorName: "나",
      content: g,
      createdAt: (/* @__PURE__ */ new Date()).toISOString(),
      deleted: !1,
      mine: !0,
      pending: !0
    }, D = E.current;
    o((I) => yt(I, F)), i(null);
    try {
      const I = await pt(t, a, g, v);
      return E.current !== D || (o((U) => U.map((k) => k.id === S ? I : k)), v === void 0 && _((U) => U + 1)), !0;
    } catch (I) {
      return E.current !== D || (o((U) => U.filter((k) => k.id !== S)), i(_e(I, "댓글을 등록하지 못했습니다."))), !1;
    }
  }, [t, a]), C = de(async (f, v) => {
    const g = v.trim();
    if (!g) return !1;
    const S = E.current;
    try {
      const F = await Et(f, g);
      return E.current !== S || o((D) => D.map((I) => I.id === f ? F : I)), !0;
    } catch (F) {
      return E.current === S && i(_e(F, "댓글을 수정하지 못했습니다.")), !1;
    }
  }, []), ie = de(async (f) => {
    const v = E.current;
    try {
      const g = await bt(f);
      return E.current !== v ? !0 : g === "soft-deleted" ? (o((S) => S.map((F) => F.id === f ? { ...F, deleted: !0, mine: !1, content: void 0, authorName: void 0 } : F)), !0) : (o((S) => {
        const F = S.find((k) => k.id === f), D = S.filter((k) => k.id !== f);
        if (!F) return D;
        if (Ce(F))
          return _((k) => Math.max(0, k - 1)), D;
        const I = F.parentId, U = D.find((k) => k.id === I);
        return U && U.deleted && !D.some((k) => k.parentId === I) ? (_((k) => Math.max(0, k - 1)), D.filter((k) => k.id !== I)) : D;
      }), !0);
    } catch (g) {
      return E.current === v && i(_e(g, "댓글을 삭제하지 못했습니다.")), !1;
    }
  }, []);
  return {
    items: n,
    loading: r,
    initialLoading: l,
    error: c,
    count: n.filter((f) => !f.deleted).length,
    hasMore: O,
    loadMore: q,
    reload: X,
    add: V,
    edit: C,
    remove: ie
  };
}
const ht = "_thread_1layy_9", vt = "_head_1layy_28", kt = "_headTitle_1layy_37", Nt = "_headCount_1layy_43", wt = "_list_1layy_54", $t = "_row_1layy_61", At = "_isReply_1layy_73", xt = "_pending_1layy_80", Xt = "_avatar_1layy_84", Ct = "_avatarGhost_1layy_98", St = "_body_1layy_103", Ft = "_meta_1layy_108", Bt = "_author_1layy_116", jt = "_dept_1layy_122", It = "_time_1layy_130", Lt = "_text_1layy_135", Dt = "_textDeleted_1layy_143", Mt = "_acts_1layy_148", Tt = "_act_1layy_148", Rt = "_actDanger_1layy_169", Pt = "_empty_1layy_175", Ot = "_error_1layy_182", qt = "_skeleton_1layy_196", Gt = "_more_1layy_219", zt = "_foot_1layy_245", Wt = "_composer_1layy_252", Kt = "_composerInput_1layy_261", Ht = "_composerActions_1layy_284", Vt = "_btn_1layy_291", Ut = "_btnPrimary_1layy_301", Qt = "_btnGhost_1layy_310", p = {
  thread: ht,
  head: vt,
  headTitle: kt,
  headCount: Nt,
  list: wt,
  row: $t,
  isReply: At,
  pending: xt,
  avatar: Xt,
  avatarGhost: Ct,
  body: St,
  meta: Ft,
  author: Bt,
  dept: jt,
  time: It,
  text: Lt,
  textDeleted: Dt,
  acts: Mt,
  act: Tt,
  actDanger: Rt,
  empty: Pt,
  error: Ot,
  skeleton: qt,
  more: Gt,
  foot: zt,
  composer: Wt,
  composerInput: Kt,
  composerActions: Ht,
  btn: Vt,
  btnPrimary: Ut,
  btnGhost: Qt
}, Ie = ["#3B82F6", "#7C3AED", "#10B981", "#F97316", "#EF4444", "#0EA5E9"];
function Jt(t) {
  let a = 0;
  for (let n = 0; n < t.length; n += 1) a = (a * 31 + t.charCodeAt(n)) % 997;
  return Ie[a % Ie.length];
}
function Yt(t) {
  const a = t.trim();
  return a ? a[0].toUpperCase() : "?";
}
const Le = 6e4, De = 36e5, Me = 864e5, Zt = 6048e5;
function ea(t) {
  const a = new Date(t).getTime();
  if (Number.isNaN(a)) return "";
  const n = Date.now() - a;
  if (n < Le) return "방금";
  if (n < De) return `${Math.floor(n / Le)}분 전`;
  if (n < Me) return `${Math.floor(n / De)}시간 전`;
  if (n < Zt) return `${Math.floor(n / Me)}일 전`;
  const o = new Date(a), r = (s) => s < 10 ? `0${s}` : String(s);
  return `${o.getFullYear()}.${r(o.getMonth() + 1)}.${r(o.getDate())}`;
}
function Se({
  placeholder: t,
  submitLabel: a,
  autoFocus: n,
  initialValue: o,
  onSubmit: r,
  onCancel: s
}) {
  const [l, d] = $(o != null ? o : ""), [c, i] = $(!1), m = Y(null);
  ae(() => {
    n && m.current && m.current.focus();
  }, [n]);
  const _ = async () => {
    const u = l.trim();
    if (!u || c) return;
    i(!0);
    const b = await r(u);
    i(!1), b && d("");
  };
  return /* @__PURE__ */ e.createElement("div", { className: p.composer }, /* @__PURE__ */ e.createElement(
    "textarea",
    {
      ref: m,
      className: p.composerInput,
      rows: o === void 0 ? 2 : 3,
      placeholder: t,
      value: l,
      disabled: c,
      onChange: (u) => d(u.target.value),
      onKeyDown: (u) => {
        const b = u.nativeEvent.isComposing;
        u.key === "Enter" && !u.shiftKey && !b && (u.preventDefault(), _()), u.key === "Escape" && s && (u.nativeEvent.stopPropagation(), s());
      }
    }
  ), /* @__PURE__ */ e.createElement("div", { className: p.composerActions }, s && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnGhost}`,
      onClick: s,
      disabled: c
    },
    "취소"
  ), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnPrimary}`,
      onClick: () => void _(),
      disabled: c || !l.trim()
    },
    c ? "보내는 중…" : a
  )));
}
function ta({
  item: t,
  replying: a,
  editing: n,
  onReply: o,
  onEdit: r,
  onSubmitReply: s,
  onSubmitEdit: l,
  onDelete: d,
  onCancel: c
}) {
  var u, b;
  const i = ut(t), m = i ? ` ${p.isReply}` : "";
  if (t.deleted)
    return /* @__PURE__ */ e.createElement("div", { className: `${p.row}${m}` }, /* @__PURE__ */ e.createElement("span", { className: `${p.avatar} ${p.avatarGhost}` }, "·"), /* @__PURE__ */ e.createElement("div", { className: p.body }, /* @__PURE__ */ e.createElement("div", { className: `${p.text} ${p.textDeleted}` }, "삭제된 댓글입니다")));
  const _ = (u = t.authorName) != null ? u : "anonymous";
  return /* @__PURE__ */ e.createElement("div", { className: `${p.row}${m}${t.pending ? ` ${p.pending}` : ""}` }, /* @__PURE__ */ e.createElement("span", { className: p.avatar, style: { background: Jt(_) } }, Yt(_)), /* @__PURE__ */ e.createElement("div", { className: p.body }, /* @__PURE__ */ e.createElement("div", { className: p.meta }, /* @__PURE__ */ e.createElement("span", { className: p.author }, _), t.dept && /* @__PURE__ */ e.createElement("span", { className: p.dept }, t.dept), /* @__PURE__ */ e.createElement("span", { className: p.time }, ea(t.createdAt)), t.updatedAt && /* @__PURE__ */ e.createElement("span", { className: p.time }, "(수정됨)")), n ? /* @__PURE__ */ e.createElement(
    Se,
    {
      placeholder: "댓글을 수정합니다",
      submitLabel: "수정",
      autoFocus: !0,
      initialValue: (b = t.content) != null ? b : "",
      onSubmit: l,
      onCancel: c
    }
  ) : /* @__PURE__ */ e.createElement("div", { className: p.text }, t.content), !n && !t.pending && /* @__PURE__ */ e.createElement("div", { className: p.acts }, !i && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.act, onClick: o }, "답글"), t.mine && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.act, onClick: r }, "수정"), t.mine && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.act} ${p.actDanger}`,
      onClick: d
    },
    "삭제"
  )), a && /* @__PURE__ */ e.createElement(
    Se,
    {
      placeholder: `${_} 님에게 답글`,
      submitLabel: "답글 등록",
      autoFocus: !0,
      onSubmit: s,
      onCancel: c
    }
  )));
}
function Sc({
  targetType: t,
  targetId: a,
  onCountChange: n,
  autoFocus: o,
  showHeader: r = !0,
  className: s,
  style: l
}) {
  const { items: d, initialLoading: c, loading: i, error: m, count: _, hasMore: u, loadMore: b, reload: y, add: E, edit: h, remove: w } = gt(t, a), [X, T] = $(null), [O, q] = $(null);
  ae(() => {
    T(null), q(null);
  }, [t, a]);
  const V = Y(n);
  return V.current = n, ae(() => {
    !c && V.current && V.current(_);
  }, [_, c]), /* @__PURE__ */ e.createElement("div", { className: s ? `${p.thread} ${s}` : p.thread, style: l }, r && /* @__PURE__ */ e.createElement("div", { className: p.head }, /* @__PURE__ */ e.createElement("span", { className: p.headTitle }, "댓글"), /* @__PURE__ */ e.createElement("span", { className: p.headCount }, _)), /* @__PURE__ */ e.createElement("div", { className: p.list }, c && /* @__PURE__ */ e.createElement("div", { className: p.skeleton }, /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null)), m && /* @__PURE__ */ e.createElement("div", { className: p.error }, /* @__PURE__ */ e.createElement("span", null, m), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnGhost}`,
      onClick: y
    },
    "다시 시도"
  )), !c && !m && d.length === 0 && /* @__PURE__ */ e.createElement("div", { className: p.empty }, "첫 댓글을 남겨 보세요."), d.map((C) => /* @__PURE__ */ e.createElement(
    ta,
    {
      key: C.id,
      item: C,
      replying: X === C.id,
      editing: O === C.id,
      onReply: () => {
        q(null), T(C.id);
      },
      onEdit: () => {
        T(null), q(C.id);
      },
      onCancel: () => {
        T(null), q(null);
      },
      onSubmitReply: async (ie) => {
        const f = await E(ie, C.id);
        return f && T(null), f;
      },
      onSubmitEdit: async (ie) => {
        const f = await h(C.id, ie);
        return f && q(null), f;
      },
      onDelete: () => {
        w(C.id);
      }
    }
  )), u && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.more, onClick: b, disabled: i }, i ? "불러오는 중…" : "이전 댓글 더 보기")), /* @__PURE__ */ e.createElement("div", { className: p.foot }, /* @__PURE__ */ e.createElement(
    Se,
    {
      placeholder: "댓글을 입력하세요 (Enter 전송, Shift+Enter 줄바꿈)",
      submitLabel: "등록",
      autoFocus: o,
      onSubmit: (C) => E(C)
    }
  )));
}
function Fc(t, a) {
  const [n, o] = $({}), [r, s] = $(!1), [l, d] = $(0), c = a.join(",");
  return ae(() => {
    const i = c ? c.split(",") : [];
    if (i.length === 0) {
      o({});
      return;
    }
    const m = new AbortController();
    return s(!0), ft(t, i, m.signal).then((_) => {
      m.signal.aborted || o(_);
    }).catch(() => {
      m.signal.aborted || o({});
    }).finally(() => {
      m.signal.aborted || s(!1);
    }), () => m.abort();
  }, [t, c, l]), {
    counts: n,
    loading: r,
    reload: () => d((i) => i + 1)
  };
}
const aa = "_card_epi3f_1", na = "_header_epi3f_8", oa = "_headerNoDivider_epi3f_13", sa = "_body_epi3f_17", ra = "_paddingSm_epi3f_22", ca = "_paddingMd_epi3f_26", la = "_paddingLg_epi3f_30", G = {
  card: aa,
  header: na,
  headerNoDivider: oa,
  body: sa,
  paddingSm: ra,
  paddingMd: ca,
  paddingLg: la
};
function Bc({
  children: t,
  header: a,
  padding: n = "md",
  radius: o,
  headerDivider: r = !0,
  headerBackground: s,
  headerPadding: l,
  headerBorderColor: d,
  className: c
}) {
  const i = typeof n == "number" ? "" : n === "sm" ? G.paddingSm : n === "lg" ? G.paddingLg : G.paddingMd, m = typeof n == "number" ? { padding: n } : void 0, _ = c ? `${G.card} ${c}` : G.card, u = r ? G.header : `${G.header} ${G.headerNoDivider}`, b = {
    ...s !== void 0 ? { background: s } : {},
    ...l !== void 0 ? { padding: l } : {},
    ...d !== void 0 ? { borderBottomColor: d } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: _, style: o !== void 0 ? { borderRadius: o } : void 0 }, a && /* @__PURE__ */ e.createElement("div", { className: u, style: b }, a), /* @__PURE__ */ e.createElement("div", { className: `${G.body} ${i}`, style: m }, t));
}
const ia = "_horizontal_mkht7_1", da = "_vertical_mkht7_8", Te = {
  horizontal: ia,
  vertical: da
};
function jc({ orientation: t = "horizontal", spacing: a = 0, color: n }) {
  const o = t === "vertical";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: o ? Te.vertical : Te.horizontal,
      style: {
        ...o ? { marginLeft: a, marginRight: a } : { marginTop: a, marginBottom: a },
        ...n !== void 0 ? { backgroundColor: n } : {}
      },
      role: "separator",
      "aria-orientation": t
    }
  );
}
const _a = "_root_nvy8t_1", ma = "_icon_nvy8t_7", ua = "_iconBadge_nvy8t_15", pa = "_titleGroup_nvy8t_25", Ea = "_title_nvy8t_25", ba = "_subtitle_nvy8t_41", fa = "_trailing_nvy8t_49", ya = "_closeButton_nvy8t_58", Q = {
  root: _a,
  icon: ma,
  iconBadge: ua,
  titleGroup: pa,
  title: Ea,
  subtitle: ba,
  trailing: fa,
  closeButton: ya
};
function Ic({
  icon: t,
  iconColor: a,
  iconBadge: n = !1,
  iconBadgeColor: o = "#3b82f6",
  iconBadgeGradient: r,
  iconBadgeSize: s,
  title: l,
  titleWeight: d,
  titleSize: c,
  subtitle: i,
  subtitleColor: m,
  subtitleSize: _,
  trailing: u,
  onClose: b
}) {
  const y = {
    ...d !== void 0 ? { fontWeight: d } : {},
    ...c !== void 0 ? { fontSize: c } : {}
  }, E = {
    ...m !== void 0 ? { color: m } : {},
    ..._ !== void 0 ? { fontSize: _ } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: Q.root }, t && n && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Q.iconBadge,
      style: {
        ...r ? { background: `linear-gradient(135deg, ${r[0]}, ${r[1]})`, color: "#fff" } : { backgroundColor: `${o}1A`, color: o },
        ...s !== void 0 ? { width: s, height: s } : {}
      }
    },
    t
  ), t && !n && /* @__PURE__ */ e.createElement("span", { className: Q.icon, style: a !== void 0 ? { color: a } : void 0 }, t), /* @__PURE__ */ e.createElement("div", { className: Q.titleGroup }, /* @__PURE__ */ e.createElement("span", { className: Q.title, style: y }, l), i && /* @__PURE__ */ e.createElement("span", { className: Q.subtitle, style: E }, i)), u && /* @__PURE__ */ e.createElement("div", { className: Q.trailing }, u), b && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: Q.closeButton,
      onClick: b,
      "aria-label": "닫기"
    },
    "×"
  ));
}
const ga = "_badge_19977_1", ha = {
  badge: ga
};
function Lc({
  size: t = 32,
  gradient: a = ["#7C3AED", "#3B82F6"],
  icon: n
}) {
  const o = t * 0.55;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: ha.badge,
      style: {
        width: t,
        height: t,
        background: `linear-gradient(135deg, ${a[0]}, ${a[1]})`
      }
    },
    n != null ? n : /* @__PURE__ */ e.createElement("svg", { width: o, height: o, viewBox: "0 0 24 24", fill: "#fff" }, /* @__PURE__ */ e.createElement("path", { d: "M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z" }))
  );
}
const va = "_wrapper_ccmq2_1", ka = "_image_ccmq2_8", Na = "_fallback_ccmq2_16", wa = "_statusDot_ccmq2_29", ve = {
  wrapper: va,
  image: ka,
  fallback: Na,
  statusDot: wa
}, $a = {
  on: "#22C55E",
  away: "#F59E0B",
  off: "#94A3B8"
};
function Aa(t) {
  const a = t == null ? void 0 : t.trim();
  return a ? Array.from(a)[0].toUpperCase() : "";
}
const $e = [
  "#EF4444",
  "#F97316",
  "#F59E0B",
  "#10B981",
  "#0EA5E9",
  "#3B82F6",
  "#6366F1",
  "#8B5CF6",
  "#D946EF",
  "#EC4899"
];
function xa(t) {
  const a = t == null ? void 0 : t.trim();
  if (!a) return $e[5];
  let n = 0;
  for (let o = 0; o < a.length; o += 1)
    n = n * 31 + a.charCodeAt(o) | 0;
  return $e[Math.abs(n) % $e.length];
}
function Ye({
  src: t,
  fallbackText: a,
  alt: n,
  size: o = 32,
  statusDot: r,
  color: s,
  ring: l = !1,
  ringColor: d = "#fff"
}) {
  var _;
  const [c, i] = $(), m = !!t && c !== t;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: ve.wrapper,
      style: {
        width: o,
        height: o,
        ...l ? { boxShadow: `0 0 0 2px ${d}` } : {}
      }
    },
    m ? /* @__PURE__ */ e.createElement(
      "img",
      {
        className: ve.image,
        src: t,
        alt: (_ = n != null ? n : a) != null ? _ : "",
        onError: () => i(t)
      }
    ) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: ve.fallback,
        style: {
          backgroundColor: s != null ? s : xa(a),
          fontSize: Math.max(10, o * 0.45)
        }
      },
      Aa(a)
    ),
    r && /* @__PURE__ */ e.createElement(
      "span",
      {
        className: ve.statusDot,
        style: {
          backgroundColor: $a[r],
          width: Math.max(8, o * 0.28),
          height: Math.max(8, o * 0.28)
        }
      }
    )
  );
}
const Xa = "_stack_y8phg_1", Ca = "_item_y8phg_6", Sa = "_overflow_y8phg_18", ke = {
  stack: Xa,
  item: Ca,
  overflow: Sa
};
function Dc({
  avatars: t,
  max: a = 4,
  size: n = 32
}) {
  const o = t.slice(0, a), r = t.length - o.length;
  return /* @__PURE__ */ e.createElement("span", { className: ke.stack }, o.map((s, l) => /* @__PURE__ */ e.createElement("span", { key: l, className: ke.item, style: { zIndex: o.length - l } }, /* @__PURE__ */ e.createElement(Ye, { src: s.src, alt: s.alt, fallbackText: s.fallbackText, size: n }))), r > 0 && /* @__PURE__ */ e.createElement("span", { className: ke.item, style: { zIndex: 0 } }, /* @__PURE__ */ e.createElement(
    "span",
    {
      className: ke.overflow,
      style: { width: n, height: n, fontSize: Math.max(10, n * 0.36) }
    },
    "+",
    r
  )));
}
const Fa = "_badge_1mjda_1", Ba = "_pill_1mjda_15", ja = "_dot_1mjda_19", Ia = "_dotPulse_1mjda_26", La = "_outline_1mjda_40", Da = "_soft_1mjda_46", me = {
  badge: Fa,
  pill: Ba,
  dot: ja,
  dotPulse: Ia,
  "ax-badge-pulse": "_ax-badge-pulse_1mjda_1",
  default: "_default_1mjda_35",
  outline: La,
  soft: Da
};
function Mc({
  label: t,
  variant: a = "default",
  color: n,
  background: o,
  textColor: r,
  shape: s = "rounded",
  dot: l = !1,
  dotColor: d,
  dotPulse: c = !1,
  border: i = !1,
  borderColor: m = "currentColor"
}) {
  var y;
  const _ = {};
  n && (a === "default" ? (_.backgroundColor = n, _.color = "#fff") : a === "outline" ? (_.borderColor = n, _.color = n) : (_.backgroundColor = `${n}1A`, _.color = n)), o !== void 0 && (_.backgroundColor = o), r !== void 0 && (_.color = r), i && (_.borderColor = m);
  const u = [
    me.badge,
    me[a],
    s === "pill" ? me.pill : ""
  ].filter(Boolean).join(" "), b = [me.dot, c ? me.dotPulse : ""].filter(Boolean).join(" ");
  return /* @__PURE__ */ e.createElement("span", { className: u, style: _ }, l && /* @__PURE__ */ e.createElement("span", { className: b, style: { backgroundColor: d != null ? d : (y = r != null ? r : n) != null ? y : "currentColor" } }), t);
}
const Ma = "_row_1k2ap_1", Ta = "_reply_1k2ap_7", Ra = "_avatar_1k2ap_12", Pa = "_avatarImage_1k2ap_25", Oa = "_avatarFallback_1k2ap_32", qa = "_body_1k2ap_44", Ga = "_headerLine_1k2ap_49", za = "_author_1k2ap_56", Wa = "_meta_1k2ap_62", Ka = "_text_1k2ap_67", Ha = "_actionsRow_1k2ap_74", Va = "_actionBtn_1k2ap_81", B = {
  row: Ma,
  reply: Ta,
  avatar: Ra,
  avatarImage: Pa,
  avatarFallback: Oa,
  body: qa,
  headerLine: Ga,
  author: za,
  meta: Wa,
  text: Ka,
  actionsRow: Ha,
  actionBtn: Va
};
function Ua(t) {
  const a = t.trim();
  return a ? a[0].toUpperCase() : "";
}
function Tc({
  avatarSrc: t,
  author: a,
  meta: n,
  text: o,
  likeCount: r,
  replyCount: s,
  isReply: l = !1,
  onLikeClick: d,
  onReplyClick: c
}) {
  const [i, m] = $(!1), _ = !!t && !i;
  return /* @__PURE__ */ e.createElement("div", { className: `${B.row} ${l ? B.reply : ""}` }, /* @__PURE__ */ e.createElement("span", { className: B.avatar }, _ ? /* @__PURE__ */ e.createElement(
    "img",
    {
      className: B.avatarImage,
      src: t,
      alt: a,
      onError: () => m(!0)
    }
  ) : /* @__PURE__ */ e.createElement("span", { className: B.avatarFallback }, Ua(a))), /* @__PURE__ */ e.createElement("div", { className: B.body }, /* @__PURE__ */ e.createElement("div", { className: B.headerLine }, /* @__PURE__ */ e.createElement("span", { className: B.author }, a), n && /* @__PURE__ */ e.createElement("span", { className: B.meta }, n)), /* @__PURE__ */ e.createElement("div", { className: B.text }, o), /* @__PURE__ */ e.createElement("div", { className: B.actionsRow }, /* @__PURE__ */ e.createElement("button", { type: "button", className: B.actionBtn, onClick: d }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" })), typeof r == "number" && /* @__PURE__ */ e.createElement("span", null, r)), /* @__PURE__ */ e.createElement("button", { type: "button", className: B.actionBtn, onClick: c }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })), typeof s == "number" && /* @__PURE__ */ e.createElement("span", null, s)))));
}
const Qa = "_wrapper_79n51_1", Ja = {
  wrapper: Qa
}, Ya = {
  pdf: { label: "PDF", color: "#B91C1C", bg: "#FEF2F2" },
  doc: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  docx: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  xls: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  xlsx: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  ppt: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  pptx: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  zip: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  rar: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  "7z": { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  jpg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  jpeg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  png: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  gif: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  svg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  mp4: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  mov: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  avi: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  txt: { label: "TXT", color: "#334155", bg: "#F8FAFC" }
}, Za = { label: "FILE", color: "#64748B", bg: "#F1F5F9" };
function en({ ext: t, size: a = 32 }) {
  var l;
  const n = t.trim().toLowerCase().replace(/^\./, ""), { label: o, color: r, bg: s } = (l = Ya[n]) != null ? l : Za;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Ja.wrapper,
      style: {
        width: a,
        height: a,
        backgroundColor: s,
        color: r,
        fontSize: Math.max(8, a * 0.26)
      }
    },
    o
  );
}
const tn = "_chip_1jhj8_1", an = "_clickable_1jhj8_12", nn = "_icon_1jhj8_21", on = "_info_1jhj8_26", sn = "_name_1jhj8_33", rn = "_size_1jhj8_42", cn = "_chipError_1jhj8_48", ln = "_chipDone_1jhj8_53", dn = "_status_1jhj8_57", _n = "_statusError_1jhj8_66", mn = "_statusDone_1jhj8_67", un = "_statusIcon_1jhj8_69", pn = "_statusLabel_1jhj8_71", En = "_progressTrack_1jhj8_78", bn = "_progressFill_1jhj8_88", fn = "_actionBtn_1jhj8_96", N = {
  chip: tn,
  clickable: an,
  icon: nn,
  info: on,
  name: sn,
  size: rn,
  chipError: cn,
  chipDone: ln,
  status: dn,
  statusError: _n,
  statusDone: mn,
  statusIcon: un,
  statusLabel: pn,
  progressTrack: En,
  progressFill: bn,
  actionBtn: fn
};
function Rc({
  name: t,
  ext: a,
  size: n,
  onRemove: o,
  downloadable: r = !1,
  onClick: s,
  status: l,
  statusText: d,
  percent: c
}) {
  const i = l === "error" ? N.chipError : l === "done" ? N.chipDone : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${N.chip} ${s ? N.clickable : ""} ${i}`,
      onClick: s,
      title: l === "error" ? d : void 0
    },
    a && /* @__PURE__ */ e.createElement("span", { className: N.icon }, /* @__PURE__ */ e.createElement(en, { ext: a, size: 28 })),
    /* @__PURE__ */ e.createElement("span", { className: N.info }, /* @__PURE__ */ e.createElement("span", { className: N.name }, t), d ? /* @__PURE__ */ e.createElement("span", { className: `${N.status} ${l === "error" ? N.statusError : l === "done" ? N.statusDone : ""}` }, l === "error" && /* @__PURE__ */ e.createElement("svg", { className: N.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.4", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "9" }), /* @__PURE__ */ e.createElement("path", { d: "M12 7v6M12 16.5v.01" })), l === "done" && /* @__PURE__ */ e.createElement("svg", { className: N.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.6", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M4 12.5l5 5L20 6.5" })), /* @__PURE__ */ e.createElement("span", { className: N.statusLabel }, d)) : n ? /* @__PURE__ */ e.createElement("span", { className: N.size }, n) : null, l === "processing" && /* @__PURE__ */ e.createElement("span", { className: N.progressTrack }, /* @__PURE__ */ e.createElement("span", { className: N.progressFill, style: { width: `${Math.max(0, Math.min(100, c != null ? c : 0))}%` } }))),
    r ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: N.actionBtn,
        "aria-label": "내려받기",
        onClick: (m) => m.stopPropagation()
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M12 3v12M7 10l5 5 5-5M4 21h16" }))
    ) : o ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: N.actionBtn,
        "aria-label": "삭제",
        onClick: (m) => {
          m.stopPropagation(), o();
        }
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18M6 6l12 12" }))
    ) : null
  );
}
const yn = "_list_1yxwc_1", gn = "_row_1yxwc_6", hn = "_inline_1yxwc_15", vn = "_label_1yxwc_22", kn = "_value_1yxwc_29", Nn = "_stacked_1yxwc_35", wn = "_bold_1yxwc_51", ne = {
  list: yn,
  row: gn,
  inline: hn,
  label: vn,
  value: kn,
  stacked: Nn,
  bold: wn
};
function Pc({
  rows: t,
  direction: a = "inline"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: `${ne.list} ${ne[a]}` }, t.map((n, o) => /* @__PURE__ */ e.createElement("div", { key: o, className: ne.row }, /* @__PURE__ */ e.createElement("span", { className: ne.label }, n.label), /* @__PURE__ */ e.createElement("span", { className: `${ne.value} ${n.bold ? ne.bold : ""}` }, n.value))));
}
const $n = "_container_2r163_1", An = "_row_2r163_5", xn = "_clickable_2r163_12", Xn = "_leading_2r163_20", Cn = "_main_2r163_26", Sn = "_titleLine_2r163_34", Fn = "_title_2r163_34", Bn = "_tags_2r163_50", jn = "_meta_2r163_57", In = "_actions_2r163_62", Ln = "_expandable_2r163_69", M = {
  container: $n,
  row: An,
  clickable: xn,
  leading: Xn,
  main: Cn,
  titleLine: Sn,
  title: Fn,
  tags: Bn,
  meta: jn,
  actions: In,
  expandable: Ln
};
function Oc({
  leading: t,
  title: a,
  meta: n,
  tags: o,
  actions: r,
  expandableContent: s,
  expanded: l = !1,
  onClick: d
}) {
  return /* @__PURE__ */ e.createElement("div", { className: M.container }, /* @__PURE__ */ e.createElement("div", { className: `${M.row} ${d ? M.clickable : ""}`, onClick: d }, t && /* @__PURE__ */ e.createElement("div", { className: M.leading }, t), /* @__PURE__ */ e.createElement("div", { className: M.main }, /* @__PURE__ */ e.createElement("div", { className: M.titleLine }, /* @__PURE__ */ e.createElement("span", { className: M.title }, a), o && /* @__PURE__ */ e.createElement("span", { className: M.tags }, o)), n && /* @__PURE__ */ e.createElement("div", { className: M.meta }, n)), r && /* @__PURE__ */ e.createElement("div", { className: M.actions, onClick: (c) => c.stopPropagation() }, r)), l && s && /* @__PURE__ */ e.createElement("div", { className: M.expandable }, s));
}
const Dn = "_row_xzgny_1", Mn = "_info_xzgny_8", Tn = "_name_xzgny_16", Rn = "_subtitle_xzgny_25", Pn = "_status_xzgny_33", ue = {
  row: Dn,
  info: Mn,
  name: Tn,
  subtitle: Rn,
  status: Pn
};
function qc({
  avatarSrc: t,
  name: a,
  subtitle: n,
  status: o,
  statusColor: r = "#64748B",
  statusBg: s = "#F1F5F9"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: ue.row }, /* @__PURE__ */ e.createElement(Ye, { src: t, fallbackText: a, size: 36 }), /* @__PURE__ */ e.createElement("div", { className: ue.info }, /* @__PURE__ */ e.createElement("span", { className: ue.name }, a), n && /* @__PURE__ */ e.createElement("span", { className: ue.subtitle }, n)), o && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: ue.status,
      style: { color: r, backgroundColor: s }
    },
    o
  ));
}
const On = "_row_qoxwr_1", qn = "_clickable_qoxwr_9", Gn = "_rank_qoxwr_17", zn = "_title_qoxwr_25", Wn = "_trailing_qoxwr_36", pe = {
  row: On,
  clickable: qn,
  rank: Gn,
  title: zn,
  trailing: Wn
}, Kn = {
  1: "#F59E0B",
  2: "#94A3B8",
  3: "#B45309"
};
function Gc({
  rank: t,
  rankColor: a,
  title: n,
  trailingText: o,
  onClick: r
}) {
  var l;
  const s = (l = a != null ? a : Kn[t]) != null ? l : "#64748B";
  return /* @__PURE__ */ e.createElement("div", { className: `${pe.row} ${r ? pe.clickable : ""}`, onClick: r }, /* @__PURE__ */ e.createElement("span", { className: pe.rank, style: { color: s } }, t), /* @__PURE__ */ e.createElement("span", { className: pe.title }, n), o && /* @__PURE__ */ e.createElement("span", { className: pe.trailing }, o));
}
const Hn = "_badge_1qibj_1", Vn = "_sm_1qibj_11", Un = "_md_1qibj_16", Qn = "_overdue_1qibj_21", Jn = "_warning_1qibj_26", Yn = "_progress_1qibj_31", Zn = "_success_1qibj_36", eo = "_info_1qibj_41", to = "_neutral_1qibj_46", Ae = {
  badge: Hn,
  sm: Vn,
  md: Un,
  overdue: Qn,
  warning: Jn,
  progress: Yn,
  success: Zn,
  info: eo,
  neutral: to
};
function zc({
  label: t,
  tone: a = "neutral",
  size: n = "md",
  background: o,
  textColor: r
}) {
  const s = {};
  return o !== void 0 && (s.backgroundColor = o), r !== void 0 && (s.color = r), /* @__PURE__ */ e.createElement("span", { className: `${Ae.badge} ${Ae[a]} ${Ae[n]}`, style: s }, t);
}
const ao = "_wrapper_14p14_1", no = "_avatar_14p14_11", oo = "_body_14p14_21", so = "_message_14p14_26", ro = "_dots_14p14_32", co = "_dot_14p14_32", lo = "_action_14p14_70", io = "_actionIcon_14p14_89", _o = "_gradientWrapper_14p14_95", mo = "_bareIcon_14p14_100", uo = "_ctaButton_14p14_109", A = {
  wrapper: ao,
  avatar: no,
  body: oo,
  message: so,
  dots: ro,
  dot: co,
  action: lo,
  actionIcon: io,
  gradientWrapper: _o,
  bareIcon: mo,
  ctaButton: uo
};
function Re() {
  return /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8 1.5l1.4 3.9L13.3 6.8l-3.9 1.4L8 12.1l-1.4-3.9L2.7 6.8l3.9-1.4L8 1.5z",
      fill: "currentColor"
    }
  ));
}
function Pe() {
  return /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3 7h8M7.5 3.5L11 7l-3.5 3.5",
      stroke: "currentColor",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ));
}
function Wc({
  message: t,
  accentColor: a = "#7C3AED",
  buttonLabel: n,
  buttonIcon: o,
  onAction: r,
  phase: s = "complete",
  variant: l = "card",
  gradientColors: d = ["#EEF4FF", "#F3EEFF"]
}) {
  const c = l === "gradient-cta";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [A.wrapper, c ? A.gradientWrapper : ""].join(" "),
      style: c ? { borderColor: `${a}33`, background: `linear-gradient(135deg, ${d[0]}, ${d[1]})` } : { borderColor: `${a}33` }
    },
    c ? /* @__PURE__ */ e.createElement("span", { className: A.bareIcon, style: { color: a } }, /* @__PURE__ */ e.createElement(Re, null)) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: A.avatar,
        style: { backgroundColor: `${a}1A`, color: a }
      },
      /* @__PURE__ */ e.createElement(Re, null)
    ),
    /* @__PURE__ */ e.createElement("div", { className: A.body }, s === "loading" ? /* @__PURE__ */ e.createElement("span", { className: A.dots }, /* @__PURE__ */ e.createElement("span", { className: A.dot, style: { backgroundColor: a } }), /* @__PURE__ */ e.createElement("span", { className: A.dot, style: { backgroundColor: a } }), /* @__PURE__ */ e.createElement("span", { className: A.dot, style: { backgroundColor: a } })) : /* @__PURE__ */ e.createElement("span", { className: A.message, style: c ? { color: a } : void 0 }, t)),
    n && r && (c ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: A.ctaButton,
        style: { backgroundColor: a },
        onClick: r
      },
      /* @__PURE__ */ e.createElement("span", null, n),
      /* @__PURE__ */ e.createElement("span", { className: A.actionIcon }, o === void 0 ? /* @__PURE__ */ e.createElement(Pe, null) : o)
    ) : /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: A.action,
        style: { color: a },
        onClick: r
      },
      /* @__PURE__ */ e.createElement("span", null, n),
      /* @__PURE__ */ e.createElement("span", { className: A.actionIcon }, o === void 0 ? /* @__PURE__ */ e.createElement(Pe, null) : o)
    ))
  );
}
const po = "_wrapper_68zkp_1", Eo = "_bordered_68zkp_13", bo = "_compact_68zkp_17", fo = "_icon_68zkp_23", yo = "_title_68zkp_31", go = "_description_68zkp_38", ho = "_action_68zkp_46", Z = {
  wrapper: po,
  bordered: Eo,
  compact: bo,
  icon: fo,
  title: yo,
  description: go,
  action: ho
};
function vo() {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15L20 8l14 7-14 7-14-7z",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15v11l14 7 14-7V15",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement("path", { d: "M20 22v11", stroke: "#94A3B8", strokeWidth: "1.6", strokeLinecap: "round" })
  );
}
function Kc({
  icon: t,
  hideIcon: a = !1,
  title: n,
  titleColor: o,
  titleSize: r,
  titleWeight: s,
  description: l,
  actionLabel: d,
  onAction: c,
  bordered: i = !0,
  compact: m = !1
}) {
  const _ = {
    ...o !== void 0 ? { color: o } : {},
    ...r !== void 0 ? { fontSize: r } : {},
    ...s !== void 0 ? { fontWeight: s } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [Z.wrapper, i && !m ? Z.bordered : "", m ? Z.compact : ""].join(" ")
    },
    !a && /* @__PURE__ */ e.createElement("div", { className: Z.icon }, t != null ? t : /* @__PURE__ */ e.createElement(vo, null)),
    /* @__PURE__ */ e.createElement("p", { className: Z.title, style: _ }, n),
    l && /* @__PURE__ */ e.createElement("p", { className: Z.description }, l),
    d && c && /* @__PURE__ */ e.createElement("button", { type: "button", className: Z.action, onClick: c }, d)
  );
}
const ko = "_wrapper_oide4_1", No = "_toggle_oide4_7", wo = "_toggleOpen_oide4_29", $o = "_panel_oide4_34", Ao = "_text_oide4_41", Ee = {
  wrapper: ko,
  toggle: No,
  toggleOpen: wo,
  panel: $o,
  text: Ao
};
function Hc({
  label: t,
  summaryText: a,
  open: n,
  onToggle: o
}) {
  return /* @__PURE__ */ e.createElement("div", { className: Ee.wrapper }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: [Ee.toggle, n ? Ee.toggleOpen : ""].join(" "),
      onClick: o,
      "aria-expanded": n
    },
    t
  ), n && /* @__PURE__ */ e.createElement("div", { className: Ee.panel }, /* @__PURE__ */ e.createElement("p", { className: Ee.text }, a)));
}
const xo = "_wrapper_96dw1_1", Xo = "_labelRow_96dw1_8", Co = "_label_96dw1_8", So = "_value_96dw1_21", Fo = "_track_96dw1_27", Bo = "_xs_96dw1_35", jo = "_sm_96dw1_39", Io = "_md_96dw1_43", Lo = "_square_96dw1_47", Do = "_fill_96dw1_51", z = {
  wrapper: xo,
  labelRow: Xo,
  label: Co,
  value: So,
  track: Fo,
  xs: Bo,
  sm: jo,
  md: Io,
  square: Lo,
  fill: Do
};
function Vc({
  value: t,
  max: a = 100,
  label: n,
  color: o = "#3B82F6",
  gradient: r,
  size: s = "md",
  rounded: l = !0,
  height: d,
  trackColor: c
}) {
  const i = a > 0 ? a : 100, m = Math.min(100, Math.max(0, t / i * 100)), _ = r ? { width: `${m}%`, background: `linear-gradient(90deg, ${r[0]}, ${r[1]})` } : { width: `${m}%`, backgroundColor: o }, u = {
    ...d !== void 0 ? { height: d } : {},
    ...c !== void 0 ? { background: c } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: z.wrapper }, n && /* @__PURE__ */ e.createElement("div", { className: z.labelRow }, /* @__PURE__ */ e.createElement("span", { className: z.label }, n), /* @__PURE__ */ e.createElement("span", { className: z.value }, Math.round(m), "%")), /* @__PURE__ */ e.createElement("div", { className: [z.track, z[s], l ? "" : z.square].join(" "), style: u }, /* @__PURE__ */ e.createElement("div", { className: [z.fill, l ? "" : z.square].join(" "), style: _ })));
}
const Mo = "_list_aixh6_1", To = "_vertical_aixh6_8", Ro = "_horizontal_aixh6_13", Po = "_item_aixh6_18", Oo = "_iconWrap_aixh6_41", qo = "_iconSvg_aixh6_51", Go = "_spin_aixh6_56", zo = "_label_aixh6_70", Wo = "_item_active_aixh6_82", Ko = "_item_done_aixh6_87", Ho = "_connector_aixh6_91", Vo = "_cardList_aixh6_114", Uo = "_cardItem_aixh6_122", Qo = "_card_pending_aixh6_133", Jo = "_card_active_aixh6_142", Yo = "_card_done_aixh6_152", x = {
  list: Mo,
  vertical: To,
  horizontal: Ro,
  item: Po,
  iconWrap: Oo,
  iconSvg: qo,
  spin: Go,
  "ax-step-spin": "_ax-step-spin_aixh6_1",
  label: zo,
  item_active: Wo,
  item_done: Ko,
  connector: Ho,
  cardList: Vo,
  cardItem: Uo,
  card_pending: Qo,
  card_active: Jo,
  card_done: Yo
};
function Zo({ status: t }) {
  return t === "done" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: x.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "9", fill: "#F0FDF4", stroke: "#166534", strokeWidth: "1.5" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 10.2l2.4 2.4L14 7",
        stroke: "#166534",
        strokeWidth: "1.7",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ) : t === "active" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: [x.iconSvg, x.spin].join(" "),
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "circle",
      {
        cx: "10",
        cy: "10",
        r: "8",
        stroke: "#E2E8F0",
        strokeWidth: "2.5"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M18 10a8 8 0 00-8-8",
        stroke: "#3B82F6",
        strokeWidth: "2.5",
        strokeLinecap: "round"
      }
    )
  ) : /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: x.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "8", stroke: "#94A3B8", strokeWidth: "1.5" })
  );
}
function Uc({
  steps: t,
  orientation: a = "vertical",
  variant: n = "timeline"
}) {
  const o = n === "card";
  return /* @__PURE__ */ e.createElement("ul", { className: [x.list, x[a], o ? x.cardList : ""].join(" ") }, t.map((r, s) => /* @__PURE__ */ e.createElement(
    "li",
    {
      key: `${r.label}-${s}`,
      className: [
        x.item,
        o ? x.cardItem : "",
        x[`item_${r.status}`],
        o ? x[`card_${r.status}`] : ""
      ].join(" ")
    },
    /* @__PURE__ */ e.createElement("span", { className: x.iconWrap }, /* @__PURE__ */ e.createElement(Zo, { status: r.status })),
    /* @__PURE__ */ e.createElement("span", { className: x.label }, r.label),
    !o && s < t.length - 1 && /* @__PURE__ */ e.createElement("span", { className: x.connector })
  )));
}
const es = "_wrapper_1ohmw_1", ts = "_icon_1ohmw_7", as = "_dots_1ohmw_14", ns = "_dot_1ohmw_14", os = "_sm_1ohmw_27", ss = "_md_1ohmw_32", ee = {
  wrapper: es,
  icon: ts,
  dots: as,
  dot: ns,
  "ax-typing-bounce": "_ax-typing-bounce_1ohmw_1",
  sm: os,
  md: ss
};
function Qc({ withIcon: t, size: a = "md" }) {
  return /* @__PURE__ */ e.createElement("div", { className: ee.wrapper }, t && /* @__PURE__ */ e.createElement("span", { className: ee.icon }, t), /* @__PURE__ */ e.createElement("span", { className: [ee.dots, ee[a]].join(" ") }, /* @__PURE__ */ e.createElement("span", { className: ee.dot }), /* @__PURE__ */ e.createElement("span", { className: ee.dot }), /* @__PURE__ */ e.createElement("span", { className: ee.dot })));
}
const rs = "_container_85404_1", cs = "_table_85404_9", ls = "_row_85404_31", is = "_striped_85404_35", ds = "_clickable_85404_43", _s = "_alignLeft_85404_47", ms = "_alignCenter_85404_51", us = "_alignRight_85404_55", ps = "_emptyCell_85404_59", W = {
  container: rs,
  table: cs,
  row: ls,
  striped: is,
  clickable: ds,
  alignLeft: _s,
  alignCenter: ms,
  alignRight: us,
  emptyCell: ps
};
function Jc({
  columns: t,
  rows: a,
  striped: n = !0,
  onRowClick: o,
  emptyMessage: r = "데이터가 없습니다"
}) {
  const s = (l) => l === "center" ? W.alignCenter : l === "right" ? W.alignRight : W.alignLeft;
  return /* @__PURE__ */ e.createElement("div", { className: W.container }, /* @__PURE__ */ e.createElement("table", { className: W.table }, /* @__PURE__ */ e.createElement("thead", null, /* @__PURE__ */ e.createElement("tr", null, t.map((l) => /* @__PURE__ */ e.createElement(
    "th",
    {
      key: l.key,
      className: s(l.align),
      style: l.width ? { width: l.width } : void 0
    },
    l.label
  )))), /* @__PURE__ */ e.createElement("tbody", null, a.length === 0 ? /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement("td", { className: W.emptyCell, colSpan: t.length }, r)) : a.map((l, d) => {
    const c = [
      W.row,
      n && d % 2 === 1 ? W.striped : "",
      o ? W.clickable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "tr",
      {
        key: d,
        className: c,
        onClick: o ? () => o(l, d) : void 0
      },
      t.map((i) => /* @__PURE__ */ e.createElement("td", { key: i.key, className: s(i.align) }, l[i.key]))
    );
  }))));
}
const Es = "_grid_plbcd_1", bs = "_cell_plbcd_6", fs = "_primaryCell_plbcd_16", ys = "_label_plbcd_21", gs = "_value_plbcd_26", hs = "_note_plbcd_32", oe = {
  grid: Es,
  cell: bs,
  primaryCell: fs,
  label: ys,
  value: gs,
  note: hs
};
function Yc({
  items: t,
  columns: a = 4,
  primaryFirst: n = !1,
  cellBackground: o,
  cellBorderColor: r,
  labelColor: s,
  valueColor: l,
  primaryBackground: d,
  primaryLabelColor: c,
  primaryValueColor: i,
  primaryNoteColor: m
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: oe.grid,
      style: { gridTemplateColumns: `repeat(${a}, 1fr)` }
    },
    t.map((_, u) => {
      const b = n && u === 0, y = [oe.cell, b ? oe.primaryCell : ""].filter(Boolean).join(" "), E = {};
      o !== void 0 && (E.background = o), r !== void 0 && (E.borderColor = r), b && d !== void 0 && (E.background = d, E.borderColor = "transparent");
      const h = {};
      s !== void 0 && (h.color = s), b && c !== void 0 && (h.color = c);
      const w = {};
      l !== void 0 && (w.color = l), b && i !== void 0 && (w.color = i);
      const X = {};
      return b && m !== void 0 && (X.color = m), /* @__PURE__ */ e.createElement("div", { key: `${_.label}-${u}`, className: y, style: E }, /* @__PURE__ */ e.createElement("span", { className: oe.label, style: h }, _.label), /* @__PURE__ */ e.createElement("span", { className: oe.value, style: w }, _.value), _.note && /* @__PURE__ */ e.createElement("span", { className: oe.note, style: X }, _.note));
    })
  );
}
const vs = "_button_16ajt_1", ks = "_disabledSolid_16ajt_19", Ns = "_icon_16ajt_26", ws = "_label_16ajt_32", $s = "_fullWidth_16ajt_37", As = "_sm_16ajt_41", xs = "_md_16ajt_47", Xs = "_lg_16ajt_53", Cs = "_primary_16ajt_59", Ss = "_secondary_16ajt_70", Fs = "_outline_16ajt_81", Bs = "_ghost_16ajt_93", js = "_active_16ajt_104", Is = "_colorOverride_16ajt_116", Ls = "_gradient_16ajt_126", Ds = "_dashed_16ajt_135", Ms = "_pill_16ajt_139", L = {
  button: vs,
  disabledSolid: ks,
  icon: Ns,
  label: ws,
  fullWidth: $s,
  sm: As,
  md: xs,
  lg: Xs,
  primary: Cs,
  secondary: Ss,
  outline: Fs,
  ghost: Bs,
  active: js,
  colorOverride: Is,
  gradient: Ls,
  dashed: Ds,
  pill: Ms
};
function Zc({
  variant: t = "primary",
  size: a = "md",
  icon: n,
  iconPosition: o = "leading",
  disabled: r = !1,
  disabledVariant: s = "dim",
  onClick: l,
  children: d,
  fullWidth: c = !1,
  type: i = "button",
  active: m = !1,
  color: _,
  background: u,
  borderColor: b,
  hoverColor: y,
  hoverBackground: E,
  gradient: h,
  borderStyle: w = "solid",
  shape: X = "rounded"
}) {
  const T = _ !== void 0 || b !== void 0 || y !== void 0 || E !== void 0, O = [
    L.button,
    L[t],
    L[a],
    c ? L.fullWidth : "",
    r && s === "solid" ? L.disabledSolid : "",
    m ? L.active : "",
    T ? L.colorOverride : "",
    h || u ? L.gradient : "",
    w === "dashed" ? L.dashed : "",
    X === "pill" ? L.pill : ""
  ].filter(Boolean).join(" "), q = {
    ..._ !== void 0 ? { "--ax-btn-color": _ } : {},
    ...b !== void 0 ? { "--ax-btn-border": b } : {},
    ...y !== void 0 ? { "--ax-btn-hover-color": y } : {},
    ...E !== void 0 ? { "--ax-btn-hover-bg": E } : {},
    ...h ? { background: `linear-gradient(135deg, ${h[0]}, ${h[1]})` } : {},
    ...u !== void 0 ? { background: u } : {}
  }, V = n && /* @__PURE__ */ e.createElement("span", { className: L.icon }, n);
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: i,
      className: O,
      style: q,
      disabled: r,
      onClick: l
    },
    o === "leading" && V,
    /* @__PURE__ */ e.createElement("span", { className: L.label }, d),
    o === "trailing" && V
  );
}
const Ts = "_iconButton_1oiog_1", Rs = "_sm_1oiog_18", Ps = "_md_1oiog_23", Os = "_lg_1oiog_28", qs = "_plain_1oiog_33", Gs = "_outline_1oiog_42", zs = "_circle_1oiog_53", Ws = "_bordered_1oiog_62", Ks = "_tint_1oiog_73", Hs = "_active_1oiog_81", Vs = "_hoverBgOverride_1oiog_92", Us = "_gradient_1oiog_96", J = {
  iconButton: Ts,
  sm: Rs,
  md: Ps,
  lg: Os,
  plain: qs,
  outline: Gs,
  circle: zs,
  bordered: Ws,
  tint: Ks,
  active: Hs,
  hoverBgOverride: Vs,
  gradient: Us
};
function el({
  icon: t,
  title: a,
  active: n = !1,
  size: o = "md",
  variant: r = "plain",
  onClick: s,
  onMouseDown: l,
  disabled: d = !1,
  color: c,
  hoverColor: i,
  bordered: m = !1,
  borderColor: _ = "#e2e8f0",
  borderHoverColor: u = "#3b82f6",
  tint: b = !1,
  tintColor: y = "#eef4ff",
  tintHoverColor: E = "#dbeafe",
  hoverBackground: h,
  gradient: w
}) {
  const X = typeof o == "number", T = [
    J.iconButton,
    X ? "" : J[o],
    J[r],
    n ? J.active : "",
    m ? J.bordered : "",
    b ? J.tint : "",
    h !== void 0 ? J.hoverBgOverride : "",
    w ? J.gradient : ""
  ].filter(Boolean).join(" "), O = {
    ...X ? { width: o, height: o } : {},
    ...c !== void 0 ? { "--ax-icon-color": c } : {},
    ...i !== void 0 ? { "--ax-icon-hover": i } : {},
    ...m ? { "--ax-icon-border": _, "--ax-icon-border-hover": u } : {},
    ...b ? { "--ax-icon-tint": y, "--ax-icon-tint-hover": E } : {},
    ...h !== void 0 ? { "--ax-icon-hover-bg": h } : {},
    ...w ? { background: `linear-gradient(135deg, ${w[0]}, ${w[1]})` } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: T,
      style: O,
      onClick: s,
      onMouseDown: l,
      disabled: d,
      title: a,
      "aria-label": a
    },
    t
  );
}
const Qs = "_control_1kv40_1", Js = "_option_1kv40_10", Ys = "_active_1kv40_28", Zs = "_sm_1kv40_37", er = "_md_1kv40_43", tr = "_dot_1kv40_49", ar = "_count_1kv40_56", nr = "_outline_1kv40_70", or = "_outlineOption_1kv40_75", K = {
  control: Qs,
  option: Js,
  active: Ys,
  sm: Zs,
  md: er,
  dot: tr,
  count: ar,
  outline: nr,
  outlineOption: or
};
function tl({
  options: t,
  value: a,
  onChange: n,
  size: o = "md",
  variant: r = "filled",
  activeBackground: s,
  activeColor: l,
  activeBorderColor: d
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [K.control, K[o], r === "outline" ? K.outline : ""].filter(Boolean).join(" "),
      role: "tablist"
    },
    t.map((c) => {
      const i = c.value === a, m = i ? {
        ...s !== void 0 ? { background: s } : {},
        ...l !== void 0 ? { color: l } : {},
        ...d !== void 0 ? { borderColor: d } : {}
      } : void 0;
      return /* @__PURE__ */ e.createElement(
        "button",
        {
          key: c.value,
          type: "button",
          role: "tab",
          "aria-selected": i,
          className: [K.option, i ? K.active : "", r === "outline" ? K.outlineOption : ""].filter(Boolean).join(" "),
          style: m,
          onClick: () => n(c.value)
        },
        c.dot && /* @__PURE__ */ e.createElement("span", { className: K.dot, style: { backgroundColor: c.dot } }),
        /* @__PURE__ */ e.createElement("span", { className: K.label }, c.label),
        typeof c.count == "number" && /* @__PURE__ */ e.createElement("span", { className: K.count }, c.count)
      );
    })
  );
}
const sr = "_chip_8jgxm_1", rr = "_clickable_8jgxm_14", cr = "_suggested_8jgxm_23", lr = "_readonly_8jgxm_33", ir = "_plusIcon_8jgxm_39", dr = "_label_8jgxm_45", _r = "_removeButton_8jgxm_50", se = {
  chip: sr,
  clickable: rr,
  default: "_default_8jgxm_18",
  suggested: cr,
  readonly: lr,
  plusIcon: ir,
  label: dr,
  removeButton: _r
};
function al({
  label: t,
  variant: a = "default",
  onRemove: n,
  onClick: o,
  background: r,
  textColor: s,
  borderColor: l
}) {
  const d = [se.chip, se[a], o ? se.clickable : ""].filter(Boolean).join(" "), i = r !== void 0 || s !== void 0 || l !== void 0 ? {
    ...r !== void 0 ? { background: r } : {},
    ...s !== void 0 ? { color: s } : {},
    ...l !== void 0 ? { borderColor: l } : {}
  } : {}, m = a !== "readonly" && !!n, _ = /* @__PURE__ */ e.createElement(e.Fragment, null, a === "suggested" && /* @__PURE__ */ e.createElement("span", { className: se.plusIcon, "aria-hidden": "true" }, "+"), /* @__PURE__ */ e.createElement("span", { className: se.label }, t), m && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: se.removeButton,
      "aria-label": `remove ${t}`,
      onClick: (u) => {
        u.stopPropagation(), n == null || n();
      }
    },
    /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ e.createElement("path", { d: "M6 6l12 12" }))
  ));
  return o ? /* @__PURE__ */ e.createElement(
    "div",
    {
      role: "button",
      tabIndex: 0,
      className: d,
      style: i,
      onClick: o,
      onKeyDown: (u) => {
        (u.key === "Enter" || u.key === " ") && (u.preventDefault(), o());
      }
    },
    _
  ) : /* @__PURE__ */ e.createElement("span", { className: d, style: i }, _);
}
const mr = "_wrapper_15dm4_1", ur = "_disabled_15dm4_8", pr = "_track_15dm4_13", Er = "_checked_15dm4_30", br = "_thumb_15dm4_34", fr = "_label_15dm4_50", re = {
  wrapper: mr,
  disabled: ur,
  track: pr,
  checked: Er,
  thumb: br,
  label: fr
};
function nl({
  checked: t,
  onChange: a,
  labelOn: n,
  labelOff: o,
  disabled: r = !1,
  color: s
}) {
  const l = t ? n : o;
  return /* @__PURE__ */ e.createElement("label", { className: [re.wrapper, r ? re.disabled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": t,
      disabled: r,
      className: [re.track, t ? re.checked : ""].filter(Boolean).join(" "),
      style: t && s !== void 0 ? { background: s } : void 0,
      onClick: () => !r && a(!t)
    },
    /* @__PURE__ */ e.createElement("span", { className: re.thumb })
  ), l && /* @__PURE__ */ e.createElement("span", { className: re.label }, l));
}
const yr = "_card_1uh3t_1", gr = "_active_1uh3t_24", hr = "_iconChip_1uh3t_29", vr = "_body_1uh3t_41", kr = "_label_1uh3t_48", Nr = "_description_1uh3t_54", ce = {
  card: yr,
  active: gr,
  iconChip: hr,
  body: vr,
  label: kr,
  description: Nr
};
function ol(t) {
  const { icon: a, label: n, description: o, active: r = !1, onClick: s } = t;
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${ce.card} ${r ? ce.active : ""}`,
      onClick: s,
      "aria-pressed": r
    },
    /* @__PURE__ */ e.createElement("span", { className: ce.iconChip }, a),
    /* @__PURE__ */ e.createElement("span", { className: ce.body }, /* @__PURE__ */ e.createElement("span", { className: ce.label }, n), o && /* @__PURE__ */ e.createElement("span", { className: ce.description }, o))
  );
}
const wr = "_breadcrumb_zkol9_1", $r = "_list_zkol9_6", Ar = "_item_zkol9_16", xr = "_link_zkol9_22", Xr = "_plain_zkol9_43", Cr = "_current_zkol9_48", Sr = "_separator_zkol9_54", te = {
  breadcrumb: wr,
  list: $r,
  item: Ar,
  link: xr,
  plain: Xr,
  current: Cr,
  separator: Sr
};
function sl(t) {
  const { items: a, separator: n = "/", textColor: o, hoverColor: r, currentColor: s } = t, l = {
    ...o !== void 0 ? { "--ax-bc-text": o } : {},
    ...r !== void 0 ? { "--ax-bc-hover": r } : {},
    ...s !== void 0 ? { "--ax-bc-current": s } : {}
  };
  return /* @__PURE__ */ e.createElement("nav", { className: te.breadcrumb, "aria-label": "breadcrumb", style: l }, /* @__PURE__ */ e.createElement("ol", { className: te.list }, a.map((d, c) => {
    const i = c === a.length - 1;
    return /* @__PURE__ */ e.createElement("li", { key: c, className: te.item }, i ? /* @__PURE__ */ e.createElement("span", { className: te.current, "aria-current": "page" }, d.label) : d.onClick ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: te.link,
        onClick: d.onClick
      },
      d.label
    ) : /* @__PURE__ */ e.createElement("span", { className: te.plain }, d.label), !i && /* @__PURE__ */ e.createElement("span", { className: te.separator, "aria-hidden": "true" }, n));
  })));
}
const Fr = "_treeItem_1ouqz_1", Br = "_active_1ouqz_18", jr = "_chevron_1ouqz_28", Ir = "_chevronExpanded_1ouqz_48", Lr = "_chevronSpacer_1ouqz_52", Dr = "_icon_1ouqz_57", Mr = "_label_1ouqz_69", Tr = "_count_1ouqz_76", Rr = "_dark_1ouqz_86", H = {
  treeItem: Fr,
  active: Br,
  chevron: jr,
  chevronExpanded: Ir,
  chevronSpacer: Lr,
  icon: Dr,
  label: Mr,
  count: Tr,
  dark: Rr
};
function rl(t) {
  const {
    icon: a,
    label: n,
    count: o,
    indent: r = 0,
    active: s = !1,
    expandable: l = !1,
    expanded: d = !1,
    theme: c = "light",
    onToggleExpand: i,
    onClick: m
  } = t, _ = (b) => {
    b.stopPropagation(), i == null || i();
  }, u = c === "dark" ? H.dark : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${H.treeItem} ${u} ${s ? H.active : ""}`,
      style: { paddingLeft: 12 + r * 16 },
      onClick: m,
      role: "treeitem",
      "aria-selected": s,
      "aria-expanded": l ? d : void 0
    },
    l ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: `${H.chevron} ${d ? H.chevronExpanded : ""}`,
        onClick: _,
        "aria-label": d ? "Collapse" : "Expand"
      },
      /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none" }, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3 1.5L7 5L3 8.5",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ))
    ) : /* @__PURE__ */ e.createElement("span", { className: H.chevronSpacer }),
    a && /* @__PURE__ */ e.createElement("span", { className: H.icon }, a),
    /* @__PURE__ */ e.createElement("span", { className: H.label }, n),
    typeof o == "number" && /* @__PURE__ */ e.createElement("span", { className: H.count }, o)
  );
}
const Pr = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function Oe(t) {
  return Array.from(t.querySelectorAll(Pr)).filter((a) => a.getClientRects().length > 0 && getComputedStyle(a).visibility !== "hidden");
}
let qe = 0, Ge = "";
function Ze(t) {
  const a = Y(null), n = Y(t);
  n.current = t;
  const o = Y(void 0);
  return o.current === void 0 && (o.current = typeof document == "undefined" ? null : document.activeElement), ae(() => {
    var d;
    const s = a.current, l = (d = o.current) != null ? d : null;
    return s && !s.contains(document.activeElement) && (Oe(s)[0] || s).focus(), qe++ === 0 && (Ge = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --qe === 0 && (document.body.style.overflow = Ge), l && l.isConnected && typeof l.focus == "function" && l.focus();
    };
  }, []), { dialogRef: a, onKeyDown: (s) => {
    const l = a.current;
    if (!l) return;
    if (s.key === "Escape") {
      s.stopPropagation(), n.current();
      return;
    }
    if (s.key !== "Tab" || !l.contains(s.target)) return;
    const d = Oe(l);
    if (d.length === 0) {
      s.preventDefault(), l.focus();
      return;
    }
    const c = d[0], i = d[d.length - 1], m = document.activeElement;
    s.shiftKey && (m === c || m === l) ? (s.preventDefault(), i.focus()) : !s.shiftKey && m === i && (s.preventDefault(), c.focus());
  } };
}
const Or = "_backdrop_gstyy_1", qr = "_panel_gstyy_9", Gr = "_right_gstyy_21", zr = "_left_gstyy_27", Wr = "_header_gstyy_51", Kr = "_icon_gstyy_59", Hr = "_titleGroup_gstyy_66", Vr = "_kicker_gstyy_71", Ur = "_title_gstyy_66", Qr = "_subtitle_gstyy_87", Jr = "_closeButton_gstyy_93", Yr = "_body_gstyy_115", Zr = "_footer_gstyy_123", j = {
  backdrop: Or,
  panel: qr,
  right: Gr,
  left: zr,
  header: Wr,
  icon: Kr,
  titleGroup: Hr,
  kicker: Vr,
  title: Ur,
  subtitle: Qr,
  closeButton: Jr,
  body: Yr,
  footer: Zr
};
function cl(t) {
  return t.open ? /* @__PURE__ */ e.createElement(ec, { ...t }) : null;
}
function ec({
  onClose: t,
  icon: a,
  kicker: n,
  title: o,
  titleSize: r,
  titleWeight: s,
  subtitle: l,
  footer: d,
  children: c,
  side: i = "right",
  headerBackground: m,
  topOffset: _
}) {
  const { dialogRef: u, onKeyDown: b } = Ze(t), y = ze("ax-drawer-t"), E = [j.panel, i === "left" ? j.left : j.right].filter(Boolean).join(" "), h = {
    ...r !== void 0 ? { fontSize: r } : {},
    ...s !== void 0 ? { fontWeight: s } : {}
  }, w = _ !== void 0 ? { top: _, height: `calc(100vh - ${_}px)` } : void 0;
  return /* @__PURE__ */ e.createElement("div", { className: j.backdrop, onClick: t }, /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: u,
      tabIndex: -1,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": y,
      className: E,
      style: w,
      onClick: (X) => X.stopPropagation(),
      onKeyDown: b
    },
    /* @__PURE__ */ e.createElement("div", { className: j.header, style: m !== void 0 ? { background: m } : void 0 }, a && /* @__PURE__ */ e.createElement("span", { className: j.icon }, a), /* @__PURE__ */ e.createElement("div", { className: j.titleGroup }, n && /* @__PURE__ */ e.createElement("p", { className: j.kicker }, n), /* @__PURE__ */ e.createElement("h2", { className: j.title, id: y, style: h }, o), l && /* @__PURE__ */ e.createElement("p", { className: j.subtitle }, l)), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: j.closeButton,
        onClick: t,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ e.createElement("div", { className: j.body }, c),
    d && /* @__PURE__ */ e.createElement("div", { className: j.footer }, d)
  ));
}
const tc = "_backdrop_6kso7_1", ac = "_menu_6kso7_8", nc = "_alignRight_6kso7_24", oc = "_alignLeft_6kso7_28", sc = "_item_6kso7_32", rc = "_itemIcon_6kso7_50", cc = "_itemText_6kso7_59", lc = "_itemLabel_6kso7_66", ic = "_itemDescription_6kso7_72", dc = "_danger_6kso7_77", R = {
  backdrop: tc,
  menu: ac,
  alignRight: nc,
  alignLeft: oc,
  item: sc,
  itemIcon: rc,
  itemText: cc,
  itemLabel: lc,
  itemDescription: ic,
  danger: dc
};
function ll(t) {
  return t.open ? /* @__PURE__ */ e.createElement(_c, { ...t }) : null;
}
function _c({
  onClose: t,
  items: a,
  anchor: n = "right"
}) {
  const o = Y(null), r = Y(void 0);
  r.current === void 0 && (r.current = typeof document == "undefined" ? null : document.activeElement), ae(() => {
    var i, m, _;
    const c = (i = r.current) != null ? i : null;
    return (_ = (m = o.current) == null ? void 0 : m.querySelector("button")) == null || _.focus(), () => {
      c && c.isConnected && typeof c.focus == "function" && c.focus();
    };
  }, []);
  const s = [R.menu, n === "left" ? R.alignLeft : R.alignRight].filter(Boolean).join(" "), l = (c) => {
    c.onClick(), t();
  }, d = (c) => {
    var u, b;
    const i = Array.from((b = (u = o.current) == null ? void 0 : u.querySelectorAll("button")) != null ? b : []), m = i.indexOf(document.activeElement), _ = (y) => {
      var E;
      c.preventDefault(), (E = i[(y + i.length) % i.length]) == null || E.focus();
    };
    c.key === "ArrowDown" ? _(m + 1) : c.key === "ArrowUp" ? _(m <= 0 ? i.length - 1 : m - 1) : c.key === "Home" ? _(0) : c.key === "End" ? _(i.length - 1) : (c.key === "Escape" || c.key === "Tab") && (c.key === "Escape" && c.preventDefault(), t());
  };
  return /* @__PURE__ */ e.createElement(et, null, /* @__PURE__ */ e.createElement("div", { className: R.backdrop, onClick: t }), /* @__PURE__ */ e.createElement("div", { ref: o, role: "menu", className: s, onClick: (c) => c.stopPropagation(), onKeyDown: d }, a.map((c, i) => {
    const m = [R.item, c.danger ? R.danger : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "button",
      {
        key: i,
        type: "button",
        role: "menuitem",
        className: m,
        onClick: () => l(c)
      },
      c.icon && /* @__PURE__ */ e.createElement("span", { className: R.itemIcon }, c.icon),
      /* @__PURE__ */ e.createElement("span", { className: R.itemText }, /* @__PURE__ */ e.createElement("span", { className: R.itemLabel }, c.label), c.description && /* @__PURE__ */ e.createElement("span", { className: R.itemDescription }, c.description))
    );
  })));
}
const mc = "_backdrop_3pc9i_1", uc = "_card_3pc9i_12", pc = "_header_3pc9i_23", Ec = "_icon_3pc9i_31", bc = "_titleGroup_3pc9i_38", fc = "_title_3pc9i_38", yc = "_subtitle_3pc9i_50", gc = "_closeButton_3pc9i_56", hc = "_body_3pc9i_78", vc = "_footer_3pc9i_85", P = {
  backdrop: mc,
  card: uc,
  header: pc,
  icon: Ec,
  titleGroup: bc,
  title: fc,
  subtitle: yc,
  closeButton: gc,
  body: hc,
  footer: vc
};
function il(t) {
  return t.open ? /* @__PURE__ */ e.createElement(kc, { ...t }) : null;
}
function kc({
  onClose: t,
  icon: a,
  title: n,
  subtitle: o,
  footer: r,
  width: s = 480,
  children: l
}) {
  const { dialogRef: d, onKeyDown: c } = Ze(t), i = ze("ax-modal-t"), m = typeof s == "number" ? `${s}px` : s;
  return /* @__PURE__ */ e.createElement("div", { className: P.backdrop, onClick: t }, /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: d,
      tabIndex: -1,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": i,
      className: P.card,
      style: { width: m },
      onClick: (_) => _.stopPropagation(),
      onKeyDown: c
    },
    /* @__PURE__ */ e.createElement("div", { className: P.header }, a && /* @__PURE__ */ e.createElement("span", { className: P.icon }, a), /* @__PURE__ */ e.createElement("div", { className: P.titleGroup }, /* @__PURE__ */ e.createElement("h2", { className: P.title, id: i }, n), o && /* @__PURE__ */ e.createElement("p", { className: P.subtitle }, o)), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: P.closeButton,
        onClick: t,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ e.createElement("div", { className: P.body }, l),
    r && /* @__PURE__ */ e.createElement("div", { className: P.footer }, r)
  ));
}
export {
  Xe as ACTIVE_AFFILIATION_KEY_PREFIX,
  it as ACTIVE_COM_HEADER,
  dt as ACTIVE_DEPT_HEADER,
  ol as AXActionCard,
  Lc as AXAiIconBadge,
  Wc as AXAiSuggestionBanner,
  Ye as AXAvatar,
  Dc as AXAvatarStack,
  Mc as AXBadge,
  sl as AXBreadcrumb,
  Zc as AXButton,
  Bc as AXCardPanel,
  Tc as AXCommentRow,
  Sc as AXCommentThread,
  Jc as AXDataTable,
  jc as AXDivider,
  cl as AXDrawer,
  ll as AXDropdownMenu,
  Kc as AXEmptyState,
  ml as AXErpAccordion,
  ul as AXErpActionMenu,
  pl as AXErpBanner,
  El as AXErpBarChart,
  bl as AXErpButton,
  fl as AXErpCalculatorModal,
  yl as AXErpCalculatorProvider,
  gl as AXErpCalendar,
  hl as AXErpCard,
  vl as AXErpCheckGroup,
  kl as AXErpCheckList,
  Nl as AXErpCheckbox,
  wl as AXErpCodeBadge,
  $l as AXErpCodePicker,
  Al as AXErpContextHelp,
  xl as AXErpCriticalAlert,
  Xl as AXErpCsvButton,
  Cl as AXErpCsvPick,
  Sl as AXErpDataTable,
  Fl as AXErpDatePicker,
  Bl as AXErpDateRange,
  jl as AXErpDonutChart,
  Il as AXErpError,
  Ll as AXErpField,
  Dl as AXErpFileDrop,
  Ml as AXErpFilterBand,
  Tl as AXErpFormModal,
  Rl as AXErpFormRow,
  Pl as AXErpFormSection,
  Ol as AXErpGantt,
  ql as AXErpGisuField,
  Gl as AXErpGlyph,
  zl as AXErpGrid,
  Wl as AXErpGridStatus,
  Kl as AXErpHint,
  Hl as AXErpIcon,
  Vl as AXErpIconButton,
  Ul as AXErpKanban,
  Ql as AXErpKpiTile,
  Jl as AXErpKpiTileGroup,
  Yl as AXErpLinkButton,
  Zl as AXErpLoadMore,
  ei as AXErpMainScreen,
  ti as AXErpMenuAreaHead,
  ai as AXErpMenuGroup,
  ni as AXErpMiniCalendar,
  oi as AXErpModal,
  si as AXErpMoneyInput,
  ri as AXErpMsg,
  ci as AXErpNote,
  li as AXErpOverviewGrid,
  ii as AXErpPage,
  di as AXErpPageBody,
  _i as AXErpPageFrame,
  mi as AXErpPagination,
  ui as AXErpPill,
  pi as AXErpProgressBar,
  Ei as AXErpProposalBanner,
  bi as AXErpProposalCards,
  fi as AXErpProposalList,
  yi as AXErpProposalModal,
  gi as AXErpQtyInput,
  hi as AXErpQuickMenu,
  vi as AXErpRadioGroup,
  ki as AXErpReadonly,
  Ni as AXErpReadout,
  wi as AXErpSaveBar,
  $i as AXErpSearchBar,
  Ai as AXErpSelect,
  xi as AXErpShortcutHelp,
  Xi as AXErpSideBar,
  Ci as AXErpSidePanel,
  Si as AXErpSidePanelGroup,
  Fi as AXErpSkipLink,
  Bi as AXErpSortAnnounce,
  ji as AXErpSortTh,
  Ii as AXErpSpinner,
  Li as AXErpStartGuide,
  Di as AXErpStatCard,
  Mi as AXErpStateBadge,
  Ti as AXErpStepIndicator,
  Ri as AXErpSummaryCard,
  Pi as AXErpSummaryList,
  Oi as AXErpTabs,
  qi as AXErpTag,
  Gi as AXErpTagList,
  zi as AXErpTextInput,
  Wi as AXErpTitleBar,
  Ki as AXErpToastProvider,
  Hi as AXErpToggle,
  Vi as AXErpTooltip,
  Ui as AXErpTreeCell,
  Qi as AXErpVerify,
  Ji as AXErpVirtualBody,
  Yi as AXErpVisuallyHidden,
  Zi as AXErpWeekStepper,
  ed as AXErpWeekStrip,
  Hc as AXExpandableSummary,
  Rc as AXFileChip,
  en as AXFileTypeIcon,
  el as AXIconButton,
  Yc as AXKeyValueGrid,
  Pc as AXKeyValueRow,
  Oc as AXListRow,
  il as AXModal,
  Ic as AXPanelHeader,
  qc as AXPersonRow,
  Vc as AXProgressBar,
  Gc as AXRankingRow,
  td as AXSearchInput,
  tl as AXSegmentedControl,
  zc as AXStatusBadge,
  Uc as AXStepProgress,
  al as AXTagChip,
  nl as AXToggleSwitch,
  rl as AXTreeItem,
  Qc as AXTypingDots,
  ad as AX_ERP_CALENDAR_KO,
  nd as AX_ERP_DIRTY_MESSAGE,
  od as AX_ERP_SHORTCUTS,
  We as GW_ORIGIN,
  sd as JAPANESE_ERAS,
  rd as OBTPortal,
  cd as OBTResizeContainer,
  ld as OBTResizeSensor,
  ye as REFRESH_KEY,
  xe as SESSION_EXPIRED_EVENT,
  Fe as TOKEN_KEY,
  mt as activeAffiliationHeaders,
  A_ as amDigits,
  x_ as amNumber,
  ge as authorizedFetch,
  id as axErpAddDays,
  dd as axErpAriaSort,
  _d as axErpAutoLineAm,
  md as axErpCalendarLocale,
  ud as axErpChangedKeys,
  pd as axErpCodeDisplay,
  Ed as axErpCodeLabel,
  bd as axErpCodeNameOf,
  fd as axErpCompareSortValue,
  yd as axErpDownload,
  gd as axErpFileName,
  hd as axErpGisuLabel,
  vd as axErpHttpMessage,
  kd as axErpIsHelpKey,
  Nd as axErpKeepInPlace,
  wd as axErpKpiColumns,
  $d as axErpMenuItem,
  Ad as axErpMenuSection,
  xd as axErpMergeBase,
  Xd as axErpNextSort,
  Cd as axErpPageCount,
  Sd as axErpPageItems,
  Fd as axErpParsePage,
  Bd as axErpQtyDecimals,
  jd as axErpQtyFormat,
  Id as axErpQtyOutOfRange,
  Ld as axErpQtyParse,
  Dd as axErpQtyRound,
  Md as axErpQtyStep,
  Td as axErpQtyTimesUnit,
  Rd as axErpRangeValid,
  Pd as axErpRovingMove,
  Od as axErpRowActivate,
  qd as axErpSameValues,
  Gd as axErpSaveBlob,
  zd as axErpSaveCsv,
  Wd as axErpSortForest,
  Kd as axErpSortMessage,
  Hd as axErpSortValue,
  Vd as axErpSubmitShortcutLabel,
  Ud as axErpTableToCsv,
  Qd as axErpTotalLabel,
  Jd as axErpWeekOf,
  nt as clearTokens,
  $c as colors,
  Ac as configureAuth,
  Cc as configureComments,
  Yd as csvFormulaGuard,
  Zd as csvNumber,
  Je as currentUsername,
  we as decodeClaims,
  e_ as eraOf,
  t_ as eraShortDate,
  a_ as eraYearLabel,
  X_ as fmtAm,
  n_ as fmtDt,
  C_ as fmtDtMin,
  S_ as fmtNum,
  F_ as fmtNumBlank,
  B_ as fmtNumDash,
  j_ as fmtYen,
  _t as getActiveAffiliation,
  lt as getFreshToken,
  Ve as getStoredToken,
  tt as isExpired,
  He as isRefreshExpired,
  ut as isReply,
  o_ as measureMoneyMetrics,
  s_ as moneyColWidth,
  r_ as moneyColWidthForDigits,
  be as notifySessionExpired,
  xc as onSessionExpired,
  Qe as refreshTokens,
  at as saveTokens,
  Xc as setActiveAffiliation,
  st as startRefreshExpiryWatch,
  Ue as stopRefreshExpiryWatch,
  c_ as textColWidth,
  l_ as textWidth,
  I_ as toHalfWidth,
  i_ as todayLocal,
  d_ as useAXErpBusy,
  __ as useAXErpCalculator,
  m_ as useAXErpConfirm,
  u_ as useAXErpDirtyGuard,
  p_ as useAXErpEditor,
  E_ as useAXErpNotice,
  b_ as useAXErpPaged,
  f_ as useAXErpQuery,
  y_ as useAXErpQuickMenu,
  g_ as useAXErpRovingGrid,
  h_ as useAXErpRunLock,
  v_ as useAXErpShortcutHelp,
  k_ as useAXErpSubmitShortcut,
  N_ as useAXErpToast,
  w_ as useAXErpTree,
  ze as useAXErpUid,
  Fc as useCommentCounts,
  gt as useComments
};
